import { api } from "@/lib/api-client";
import {
  Button,
  getKeyValue,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@heroui/react";
import { RefreshCcw } from "lucide-react";
import { useSearchParams } from "react-router";

export const EmailActivity = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = searchParams.has("page")
    ? parseInt(searchParams.get("page")!)
    : 1;
  const perPage = searchParams.has("perPage")
    ? parseInt(searchParams.get("perPage")!)
    : 10;

  const { data, refetch, isFetching } = api.admin.useGetEmailActivity({
    page: page,
    perPage: perPage,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  return (
    <div className="mt-4 flex flex-col gap-4">
      <div className="flex flex-row gap-4">
        <Button
          isLoading={isFetching}
          onPress={() => refetch()}
          color="primary"
          isIconOnly
        >
          <RefreshCcw size={16} />
        </Button>
      </div>

      <Table
        bottomContent={
          <div className="flex w-full justify-center">
            <Pagination
              page={page}
              total={data?.totalPages ?? 1}
              onChange={(page) =>
                setSearchParams((sp) => ({
                  ...sp,
                  page: page.toString(),
                }))
              }
            />
          </div>
        }
      >
        <TableHeader>
          <TableColumn key="id">ID</TableColumn>
          <TableColumn key="receiver">Recipient</TableColumn>
          <TableColumn key="eventType">Event</TableColumn>
          <TableColumn key="timestamp">Timestamp</TableColumn>
        </TableHeader>
        <TableBody items={data?.activities ?? []}>
          {(item) => (
            <TableRow key={item.id}>
              {(columnKey) => (
                <TableCell>{getKeyValue(item, columnKey)}</TableCell>
              )}
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
